
<template>
  <div class="page1">
     <div class="h90"></div>
     <div class="content">
        <div class="title1" :class="{'up2': up2}">{{msg}}</div>
        <div class="title2">智慧物联科技的无限可能</div>
        <div class="title3">UNLIMITED POSSIBILITIES OF INTELLIGENT IOT TECHNOLOGY</div>
          <div class="video" v-if="nav == '1'">
            <video  ref="videos" id="myvideo" height="414" width="720" loop autoplay="autoplay"  data-setup="{}">
                <source src="https://grammar.oss-cn-qingdao.aliyuncs.com/online/image/notework/assets/xuanchuanpian.mp4" type="video/mp4">
            </video>
           <!--  <video id="myvideo" src="https://grammar.oss-cn-qingdao.aliyuncs.com/online/image/notework/assets/xuanchuanpian.mp4"  autoplay="autoplay" ref="videos" loop="true" muted="true" height="414" width="720"></video> -->
        </div>
       
         <div class="video" v-if="nav == '2'">
            <img :src="url + '/assets/police-index.jpg'">
        </div>
        <div class="video" v-if="nav == '3'">
            <img :src="url + '/assets/constructionSite.jpg'">
        </div>
     </div>
     <div class="bottom-nav">
        <div class="construction">
              <div class="type" @click="onRouter(1)">
                <img :src="url + '/assets/parkno.png'" v-if="nav == '1'">
                <img :src="url + '/assets/park.png'" v-else>
                智慧园区
            </div>
            <div class="type" @click="onRouter(2)">
                <img :src="url + '/assets/workno.png'" v-if="nav == '2'">
                <img :src="url + '/assets/work.png'" v-else>
                智慧警务
            </div>
           <div class="type none" @click="onRouter(3)">
                <img :src="url + '/assets/site-1.png'" v-if="nav == '3'">
                <img :src="url + '/assets/site.png'" v-else>
                智慧安防
            </div>
        </div>
     </div>
  </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
export default {
    name: 'page1',
  data() {
    return {
        url: defaultSettings.url,
        msg: '',
        nav: '1',
        autoplay:true
        // playStatus:true,
        // muteStatus:'',
        // isMute:true,
        // isPlay:true
    }
  },
  props:{
    up2: {
        type: [Boolean],
        require: false,
        default: false,
    },
  },
  watch: {
    up2 (value) {
        if (value) {
            return this.msg = '一切重新想象'
        } else {
            this.msg = ''
        }
    }
  },
  mounted() {
    this.$refs.videos.play()
    this.autoplay = true
  },
  methods: {
      onRouter (obj) {
        this.nav = obj
        this.$emit('clicknav', obj);
      }
  }
};
</script>
<style lang="less" scoped>
.page1 {
    margin:0 auto;
    text-align: center;
    // height: 100%;
    .h90{
        height:90px;
    }
    .content{
        width:1200px;
        margin:0 auto;
        .title1{
            height:100px;
            margin-top:8vh;
            font-size: 70px;
            font-weight: bold;
            color: #FFFFFF;
        }
        .title2{       
            font-size: 30px;
            color: #FFFFFF;
            margin-top:20px;
        }
        .title3{   
            font-size: 12px;
            color: #ffffff87;
            font-family: Arial;
        }
        .video{
            width:800px;
            height:45vh;
            margin:0 auto;
            margin-top:40px;
            // border:1px solid #999;
            img{
                width:38vw;
                height:40vh;
            }
            video{
                 width:38vw;
                height:40vh;
            }
        }
    }
    .bottom-nav{
        position: absolute;
        bottom:0;
        background: #000000e8;
        height:100px;
        width:100%;
        .construction{
            width:800px;
            display: flex;
            margin:0 auto;
            .type{
                width:33%;
                height:22px;
                line-height:22px;
                vertical-align: middle;
                display: inline-block;
                border-right:1px solid #ffffff75;
                font-size:20px;
                margin-top:40px;
                color:#fff;
                img{
                    width:32px;
                    height:22px;
                    margin-right:14px;
                    vertical-align: middle;
                }
            }
            .none{
                border-right:none;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/components/page1.vue